import { render, staticRenderFns } from "./ProjectVr.vue?vue&type=template&id=029196ec&scoped=true&"
import script from "./ProjectVr.vue?vue&type=script&lang=js&"
export * from "./ProjectVr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029196ec",
  null
  
)

export default component.exports